import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { editPanelGroup } from '../actions/EditPanelGroup';
export const ConfigPanelGroup = (props) => {
    const panel_groups = useAppSelector(state => state.definitions.panel_groups);
    const dispatch = useAppDispatch();
    const group = panel_groups.entities[props.id];
    if (!group) {
        return null;
    }
    return (_jsxs("div", { className: "header", children: [_jsx("div", { style: { gridColumnEnd: 'span 3' }, children: group.title }), _jsx("div", { children: _jsx("button", { className: "edit lw small", onClick: () => dispatch(editPanelGroup(props.id)), children: "\u00A0Redigera\u00A0" }) })] }));
};
